import { constructAuthenticatedRoute } from '~/core/shared/utils/routing';
import { MIDDLE_OFFICE_SETTINGS_BASE_URL } from './settings';

export const MIDDLE_OFFICE_REDIRECT_ROUTES = {
  settingsRedirect: constructAuthenticatedRoute(
    MIDDLE_OFFICE_SETTINGS_BASE_URL,
    'Settings',
    `${MIDDLE_OFFICE_SETTINGS_BASE_URL}/account`,
  ),
} as const;
